<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('adminticket')" :directory="$t('datatables')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <!-- <button type="button"
                            class="btn btn-primary btn-with-shadow"
                            data-toggle="modal"
                            @click="opencreate">
                        {{ $t('new_task') }}
                    </button> -->
                </div>
            </div>
        </div>

        <app-table
            :id="tableId"
            :options="options"
            :mydata="this.tabledata"
            @action="getListAction"
        />

        <!-- <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
        /> -->
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import {TableHelpers} from '../../Demo/Tables/mixins/TableHelpers';
import AppFunction from "../../../../../core/helpers/app/AppFunction";


export default {
    extends: CoreLibrary,
    name: "DatatableWithFilter",
    mixins: [TableHelpers],
    data() {
        return {
            tabledata: [],
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'advance-table',
            rowData: {},
            options: {
                name: 'AdvanceTable',
                url: actions.TASK_LISTING,
                // url: actions.DATATABLE_DATA,
                showHeader: true,
                columns: [
                        {
                            title: this.$t('task'),
                            type: 'custom-html',
                            key: 'title',
                            modifier: (value) => {
                                return `<span>${this.$t(value)}</span>`
                            }
                        },
                        {
                            title: this.$t('assigned_to'),
                            type: 'custom-html',
                            key: 'assigned_to',
                            modifier: (value) => {
                                return `<span>${this.$t(value)}</span>`
                            }
                        },
                        {
                            title: this.$t('start_date'),
                            type: 'custom-html',
                            key: 'start_date',
                            modifier: (value) => {
                                return `<span>${this.$t(value)}</span>`
                            }
                        },
                        {
                            title: this.$t('due_date'),
                            type: 'custom-html',
                            key: 'due_date',
                            modifier: (value) => {
                                var result = '';
                                let ClassName = "warning";

                                const moment = require('moment');
                                // Define your due date and current date
                                const dueDate = moment(value+' 23:59:59'); // Replace with your due date
                                const currentDate = moment(); // Current date and time

                                // Calculate the difference in time
                                const timeDiff = dueDate.diff(currentDate);
                                if (timeDiff > 0) {
                                const duration = moment.duration(timeDiff);
                                if (duration.days() > 0) {
                                    result = `${duration.days()} day${duration.days() > 1 ? 's' : ''} left`;
                                    if(duration.days() > 30) {
                                    ClassName = 'success';
                                    }
                                } else if (duration.hours() > 0) {
                                    result = `${duration.hours()} hour${duration.hours() > 1 ? 's' : ''} left`;
                                } else {
                                    result = `${duration.minutes()} minute${duration.minutes() > 1 ? 's' : ''} left`;
                                }
                                } else {
                                    result = 'The due date has passed.';
                                    ClassName = 'danger';
                                }
                                // return `<span>${this.$t(result)}</span>`;
                                return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                                    result
                                )}</span>`;
                            }
                        },
                        {
                            title: this.$t('priority'),
                            type: 'custom-html',
                            key: 'priority',
                            modifier: (value) => {
                                return `<span>${this.$t(value)}</span>`
                            }
                        },
                        {
                            title: this.$t('status'),
                            type: 'custom-html',
                            key: 'status',
                            isVisible: true,
                            modifier: (value) => {
                                let ClassName = 'danger';

                                if (value === 'active') ClassName = `success`;
                                else if (value === 'invited') ClassName = `warning`;

                                return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(value)}</span>`;
                            }
                        },
                  {
                    title: this.$t("forms_status"),
                    type: "custom-html",
                    key: "form_published",
                    isVisible: true,
                    modifier: (value) => {
                      let className = "danger";
                      let text = "Draft";

                      if (value === true) {
                        className = "success";
                        text = "Published";
                      } else if (value === false) {
                        className = "warning";
                        text = "Unpublished";
                      }

                      return `<span class="badge badge-sm badge-pill badge-${className}">${text}</span>`;
                    }
                  }
                    ],
                actions: [
                    // {
                    //     title: this.$t('edit'),
                    //     icon: 'edit',
                    //     type: 'none',
                    //     component: 'app-add-modal',
                    //     modalId: 'demo-add-edit-Modal'
                            
                    // },
                    // {
                    //     title: this.$t('delete'),
                    //     icon: 'trash',
                    //     type: 'none',
                    //     component: 'app-confirmation-modal',
                    //     modalId: 'demo-delete',
                    // },
                    {
                        title: this.$t('view'),
                        icon: 'eye',
                        type: 'none',
                        // component: 'app-add-modal',
                        // modalId: 'demo-add-edit-Modal',
                    },
                ],
                filters: [
                    {
                        "title": this.$t('date'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "last7Days", "nextYear"]
                    },
                    {
                        "title": this.$t('age'),
                        "type": "range-filter",
                        "key": "age-range",
                        "maxTitle": this.$t('max_age'),
                        "minTitle": this.$t('min_age'),
                        "sign": ""
                    },
                    {
                        "title": this.$t('status'),
                        "type": "checkbox",
                        "key": "status",
                        "option": [
                            {id: 'complete', value: 'complete'},
                            {id: 'incomplete', value: 'Incomplete'},
                        ],
                    },
                    {
                        "title": this.$t('search_and_select'),
                        "type": "drop-down-filter",
                        "key": "search select",
                        "option": [],
                    }
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
        this.options.columns = [...this.options.columns, this.actionObj];
        this.searchAndSelectFilterOptions();
    },
    methods: {
        opencreate()
        {
            window.location = 'tasks/create'
        },

        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        getListAction(rowData, actionObj, active) {
            // if (actionObj.title == 'Delete') {
            //     this.openDeleteModal();
            // } else if (actionObj.title == this.$t('edit')) {
            //     window.location = 'tasks/edit/' + rowData.id;
            // }
            // else 
            if(actionObj.title ==  this.$t('view'))
            {
                  window.location = 'ticket/edit'
            }
               
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.DATATABLE_DATA}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    this.searchAndSelectFilterOptions();
                }).catch(({error}) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
        searchAndSelectFilterOptions() {
            this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then(response => {
                let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));

                name.option = response.data.map(name => {
                    return {
                        id: name.name,
                        value: name.name
                    }
                });
            });
        }
    },
}
</script>
